export enum RenewalMetric {
    DOLLARS = "DOLLARS",
    HOURS = "HOURS",  DAYS ="DAYS", MONTHS = "MONTHS", YEARS= "YEARS"
}